<template>
  <div class="container-fluid mycontainer-fluid content">
    <br />
    <a @click="$parent.hidePlan()">&#x025c2; Вернуться к документам</a>
    <br />
    <br />
    <div class="content-title content-mb-14">
      1. Состав оборудования в проекте, планируемого к приобретению
    </div>
    <EquipmentZaim></EquipmentZaim>

    <div class="content-title content-mb-14">
      2. Состав комплектующих и материалов в проекте, планируемых к приобретению
      за счет займа
    </div>
    <EquipmentComponentsMaterials></EquipmentComponentsMaterials>

    <div class="content-title content-mb-14">
      3. РИД, лицензии и патенты, ноу-хау, приобретаемые за счёт средств займа
    </div>
    <EquipmentLicensesPatentsEcology></EquipmentLicensesPatentsEcology>
  </div>
</template>

<script>
import { ProjectsService } from "@/common/api.service";
import UFDopInfo from "@/components/project/form/partial/UFDopInfo";
import EquipmentZaim from "@/components/project/form/partial/EquipmentZaim";
import EquipmentComponentsMaterials from "@/components/project/form/partial/EquipmentComponentsMaterials";
import EquipmentLicensesPatents from "@/components/project/form/partial/EquipmentLicensesPatents";
import EquipmentLicensesPatentsEcology from "@/components/project/form/partial/EquipmentLicensesPatentsEcology";

export default {
  name: "step7improving_ecology",
  components: {
    EquipmentLicensesPatentsEcology,
    EquipmentLicensesPatents,
    EquipmentComponentsMaterials,
    EquipmentZaim,
    UFDopInfo
  },
  props: ["step", "project"],

  data() {
    return {
      siteUrl: "",
      FILE_DOCUMENTS_PATH: [],
      showDD: true
    };
  },
  mounted() {
    this.getDocInfo();
  },
  methods: {
    getFileName(file) {
      let p = file.split("/");
      return p[p.length - 1];
    },
    getDocInfo() {
      ProjectsService.getDocumentESProjects(2845).then(({ data }) => {
        data.FILE_DOCUMENTS_PATH[14373]
          ? (this.FILE_DOCUMENTS_PATH = data.FILE_DOCUMENTS_PATH[14373])
          : (this.showDD = false);
      }, this);
    }
  }
};
</script>

<style scoped></style>
